/**
 * Thrown when network requests to the Auth server fail.
 */
export class GenericError extends Error {
  constructor(
    public error: string,
    public error_description: string,
  ) {
    super(error_description);

    Object.setPrototypeOf(this, GenericError.prototype);
  }

  static fromPayload({
    error,
    error_description,
  }: {
    error: string;
    error_description: string;
  }): GenericError {
    return new GenericError(error, error_description);
  }
}
